'use strict';
const angular = require('angular');

/*@ngInject*/
export function StorageService($resource) {

  return $resource('/api/storage/:id/:controller', {
    id: '@_id'
  },{
    getPublic: {
      method: 'GET',
      url: "/api/storage/public/:id"
    },
    getMeta: {
      method: 'GET',
      params: {
        controller: 'meta'
      }
    },
    queryByOwner: {
      method: 'GET',
      url: "/api/storage/owner/:userid",
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    transformImage: {
      method: 'PUT',
      url: "/api/storage/:id/image-transform"
    },
    getImageMeta: {
      method: 'GET',
      url: '/api/storage/:id/image-meta'
    },
    getFileSize: {
      method: 'GET',
      url: '/api/storage/:id/file-size'
    }
  });

}

export default angular.module('conduu.ap.services.StorageService', [])
  .factory('StorageService', StorageService)
  .name;



// WEBPACK FOOTER //
// ./client/~ap/services/storage/storage.service.js